/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { InputWrapperProps } from './types';

export const InputWrapper = styled.div<InputWrapperProps>`
  margin-bottom: ${(props) => (props.noMargin ? '0' : '15px')};
  vertical-align: top;

  width: calc(
    ${(props) => (props.split ? '50%' : props.width ?? '100%')} -
      ${(props) => (props.split || props.inline ? (props.last ? '0px' : '15px') : '0px')}
  );
  display: ${(props) => (props.split || props.inline ? 'inline-block' : 'block')};

  ${(props) => props.whiteBackground && 'background-color: white; border-radius: 15px;'}

  ${(props) =>
    !(props.last ?? false) &&
    (props.split || props.inline) &&
    `
    margin-right: 15px;
  `}

  ${(props) =>
    props.fullWidthBreakpoint !== null &&
    `
  ${mediaQuery(props.fullWidthBreakpoint ?? 'medium')} {
    width: 100%;
  }
`}
`;
